import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../../query/users/queries";
import { DataView } from "../../../../shared/components/DataView";
import { WSAlert } from "@wingspanhq/fe-component-library";
import { formatPhone } from "../../../../shared/utils/formatPhone";
import {
  TAX_FILING_1099_FILING_UPDATE_SUPPORT_INFORMATION_PATH,
  useGoToTaxFilingPath
} from "../../paths";

export const SupportInformation: React.FC<{}> = () => {
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);

  const goToSupport = useGoToTaxFilingPath(
    TAX_FILING_1099_FILING_UPDATE_SUPPORT_INFORMATION_PATH
  );

  const member = queryMember.data;

  return (
    <DataView
      loading={queryMember.isLoading}
      onEdit={() => {
        goToSupport();
      }}
      title="Support information"
      data={[
        {
          label: "Support email",
          value: member?.profile.company?.supportEmail
        },
        {
          label: "Support phone number",
          value: member?.profile.company?.supportPhoneNumber
            ? formatPhone(member?.profile.company?.supportPhoneNumber)
            : undefined
        }
      ]}
    >
      {!member?.profile.company?.supportEmail ||
      !member?.profile.company?.supportPhoneNumber ? (
        <WSAlert theme="warning" title="Information required" icon="alert">
          This information is required for your contractors to contact you
          during tax filing season.
        </WSAlert>
      ) : null}
    </DataView>
  );
};
